import React, { forwardRef } from 'react';

import { IconButton as MuiIconButton } from '@mui/material';

import defaultStyles from './iconButtonV2.style';

const IconButtonV2 = forwardRef(
  ({ children, variant = 'contained', styles = {}, ...props }, ref) => {
    return (
      <MuiIconButton
        variant={variant}
        sx={{
          ...(variant !== 'text' && defaultStyles.button),
          ...(variant === 'outlined' && defaultStyles.outlinedButton),
          ...styles,
        }}
        {...props}
        ref={ref}
      >
        {children}
      </MuiIconButton>
    );
  }
);

export default IconButtonV2;
